/* ================================================
   JUMP BOOTFIT — Theme JS v2 (fixes complets)
   Vanilla JS — no dependencies
   ================================================ */

(function() {
  'use strict';

  // ========== UTILS ==========
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  const formatMoney = (cents) => {
    const amount = (cents / 100).toFixed(2);
    const sep = window.theme?.decimalSep || ',';
    return amount.replace('.', sep) + ' €';
  };

  // ========== CART API ==========
  const Cart = {
    async get() {
      const res = await fetch('/cart.js');
      return res.json();
    },
    async add(formData) {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData
      });
      return res.json();
    },
    async update(updates) {
      const res = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates })
      });
      return res.json();
    },
    async change(key, quantity) {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      });
      return res.json();
    }
  };

  // ========== CART DRAWER ==========
  const CartDrawer = {
    init() {
      this.drawer = $('[data-cart-drawer]');
      this.overlay = $('[data-cart-overlay]');
      this.content = $('[data-cart-drawer-content]');

      if (!this.drawer) return;

      // Open triggers (cart icons in header etc) - statique, jamais re-rendu
      $$('[data-cart-trigger]').forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          this.open();
        });
      });

      // Overlay click - statique
      this.overlay?.addEventListener('click', () => this.close());

      // ESC key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen()) this.close();
      });

      // Delegated click handler sur le drawer parent (qui ne se re-rend jamais)
      // → tous les boutons à l'intérieur survivent aux refresh AJAX
      this.drawer.addEventListener('click', async (e) => {
        const close = e.target.closest('[data-cart-close]');
        const dec = e.target.closest('[data-cart-decrease]');
        const inc = e.target.closest('[data-cart-increase]');
        const rem = e.target.closest('[data-cart-remove]');

        if (close) {
          e.preventDefault();
          this.close();
          return;
        }
        if (dec) {
          e.preventDefault();
          const key = dec.dataset.key;
          const item = dec.closest('[data-cart-item]');
          const qtyEl = item?.querySelector('[data-cart-qty]');
          const currentQty = parseInt(qtyEl?.textContent || '1');
          await this.updateQuantity(key, currentQty - 1);
        }
        if (inc) {
          e.preventDefault();
          const key = inc.dataset.key;
          const item = inc.closest('[data-cart-item]');
          const qtyEl = item?.querySelector('[data-cart-qty]');
          const currentQty = parseInt(qtyEl?.textContent || '1');
          await this.updateQuantity(key, currentQty + 1);
        }
        if (rem) {
          e.preventDefault();
          const key = rem.dataset.key;
          await this.updateQuantity(key, 0);
        }
      });

      // Intercept add to cart forms (PDP)
      $$('form[action*="/cart/add"]').forEach(form => {
        form.addEventListener('submit', (e) => this.handleAddForm(e, form));
      });
    },

    isOpen() {
      return this.drawer?.classList.contains('is-open');
    },

    open() {
      if (this.drawer) {
        this.drawer.classList.add('is-open');
      }
      if (this.overlay) {
        this.overlay.classList.add('is-open');
      }
      document.body.style.overflow = 'hidden';
    },

    close() {
      this.drawer?.classList.remove('is-open');
      this.overlay?.classList.remove('is-open');
      document.body.style.overflow = '';
    },

    async updateQuantity(key, qty) {
      if (!key) return;
      try {
        await Cart.change(key, qty);
        await this.refresh();
      } catch (err) {
        console.error('Cart update failed:', err);
      }
    },

    async handleAddForm(e, form) {
      e.preventDefault();
      const btn = form.querySelector('[type="submit"]');
      const originalText = btn?.innerHTML;

      if (btn) {
        btn.disabled = true;
        btn.innerHTML = 'Ajout en cours…';
      }

      try {
        // Détecter le mode bundle (pack) via l'attribut data-bundle-variants sur le form
        const mainQty = parseInt(form.dataset.mainQty || '1', 10) || 1;
        const overrideId = form.dataset.overrideId;
        const bundleAttr = form.dataset.bundleVariants;
        const isBundle = (bundleAttr && bundleAttr.trim().length > 0) || mainQty > 1 || (overrideId && overrideId.length > 0);

        if (isBundle) {
          // === MODE PACK : produit principal + produits secondaires en un seul appel
          const variantSelect = form.querySelector('select[name="id"], [data-variant-select]');
          const mainVariantId = (overrideId && overrideId.length > 0) ? overrideId : variantSelect?.value;
          if (!mainVariantId) throw new Error('Aucune variante sélectionnée');

          const bundleIds = (bundleAttr || '').split(',').map(s => s.trim()).filter(Boolean);
          const items = [
            { id: parseInt(mainVariantId), quantity: mainQty },
            ...bundleIds.map(id => ({ id: parseInt(id), quantity: 1 }))
          ];

          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ items })
          });

          if (!res.ok) {
            const err = await res.json();
            throw new Error(err.description || err.message || 'Erreur ajout du pack au panier');
          }
        } else {
          // === MODE NORMAL (variante seule) ===
          const formData = new FormData(form);
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Accept': 'application/json' },
            body: formData
          });

          if (!res.ok) {
            const err = await res.json();
            throw new Error(err.description || 'Erreur ajout au panier');
          }
        }

        await this.refresh();
        this.open();

        if (btn) {
          btn.innerHTML = '✓ Ajouté';
          setTimeout(() => {
            btn.innerHTML = originalText;
            btn.disabled = false;
          }, 1500);
        }
      } catch (err) {
        console.error('Add to cart failed:', err);
        alert(err.message || 'Erreur lors de l\'ajout au panier');
        if (btn) {
          btn.innerHTML = originalText;
          btn.disabled = false;
        }
      }
    },

    async refresh() {
      try {
        // Refresh via fetching the current page (the cart-drawer snippet is rendered on every page)
        const res = await fetch(window.location.pathname + '?_drawer_refresh=' + Date.now());
        if (res.ok) {
          const html = await res.text();
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newContent = doc.querySelector('[data-cart-drawer-content]');
          if (newContent && this.content) {
            this.content.innerHTML = newContent.innerHTML;
          }
        }

        // Update header count from API (most reliable)
        const cart = await Cart.get();
        $$('[data-cart-count]').forEach(el => {
          el.textContent = cart.item_count;
          if (cart.item_count > 0) {
            el.style.display = '';
          } else {
            el.style.display = 'none';
          }
        });
      } catch (err) {
        console.error('Cart refresh failed:', err);
        // Soft fallback: just update count, don't reload
        try {
          const cart = await Cart.get();
          $$('[data-cart-count]').forEach(el => {
            el.textContent = cart.item_count;
          });
        } catch (e) {}
      }

      // Après chaque refresh, on relance le timer s'il y a des items
      CartTimer.refresh();
    }
  };

  // ========== CART TIMER (réservation 10 min) ==========
  const CartTimer = {
    DURATION: 10 * 60 * 1000, // 10 minutes en ms
    STORAGE_KEY: 'jb_cart_reserved_until',
    interval: null,

    refresh() {
      // Stopper l'ancien interval s'il existe
      if (this.interval) {
        clearInterval(this.interval);
        this.interval = null;
      }

      const timerBlock = document.querySelector('[data-cart-timer]');
      if (!timerBlock) {
        // Pas de bloc timer → panier vide → reset
        localStorage.removeItem(this.STORAGE_KEY);
        return;
      }

      const display = timerBlock.querySelector('[data-cart-timer-display]');
      const fill = timerBlock.querySelector('[data-cart-timer-fill]');
      if (!display) return;

      // Récupérer ou initialiser le timestamp de fin
      let endTime = parseInt(localStorage.getItem(this.STORAGE_KEY) || '0');
      const now = Date.now();

      if (!endTime || endTime < now) {
        // Pas de timer en cours ou expiré → démarrer un nouveau
        endTime = now + this.DURATION;
        localStorage.setItem(this.STORAGE_KEY, String(endTime));
      }

      const update = () => {
        const remaining = endTime - Date.now();
        if (remaining <= 0) {
          // Timer écoulé → vider le panier
          display.textContent = '00:00';
          if (fill) fill.style.width = '0%';
          clearInterval(this.interval);
          this.interval = null;
          localStorage.removeItem(this.STORAGE_KEY);
          this.clearCart();
          return;
        }

        const totalSeconds = Math.ceil(remaining / 1000);
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;
        display.textContent = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;

        if (fill) {
          const percent = (remaining / this.DURATION) * 100;
          fill.style.width = Math.max(0, percent) + '%';
        }
      };

      update();
      this.interval = setInterval(update, 1000);
    },

    async clearCart() {
      try {
        await fetch('/cart/clear.js', { method: 'POST' });
        // Refresh le drawer pour montrer "panier vide"
        if (window.theme?.CartDrawer) {
          await window.theme.CartDrawer.refresh();
        }
      } catch (err) {
        console.error('Cart clear failed:', err);
      }
    }
  };

  // ========== MOBILE MENU ==========
  const MobileMenu = {
    init() {
      const drawer = $('[data-menu-drawer]');
      const overlay = $('[data-menu-overlay]');

      $$('[data-menu-trigger]').forEach(btn => {
        btn.addEventListener('click', () => {
          drawer?.classList.add('is-open');
          overlay?.classList.add('is-open');
          document.body.style.overflow = 'hidden';
        });
      });

      $$('[data-menu-close]').forEach(btn => {
        btn.addEventListener('click', () => {
          drawer?.classList.remove('is-open');
          overlay?.classList.remove('is-open');
          document.body.style.overflow = '';
        });
      });

      overlay?.addEventListener('click', () => {
        drawer?.classList.remove('is-open');
        overlay?.classList.remove('is-open');
        document.body.style.overflow = '';
      });
    }
  };

  // ========== COUNTDOWN ==========
  const Countdown = {
    init() {
      const els = $$('[data-countdown]');
      if (!els.length) return;

      const endHours = parseInt(els[0].dataset.countdownHours || '23');
      const end = new Date();
      end.setHours(end.getHours() + endHours);
      end.setMinutes(end.getMinutes() + Math.floor(Math.random() * 60));

      const update = () => {
        const now = new Date();
        const diff = end - now;
        if (diff < 0) {
          els.forEach(el => el.textContent = '00:00:00');
          return;
        }
        const h = Math.floor(diff / 3600000);
        const m = Math.floor((diff % 3600000) / 60000);
        const s = Math.floor((diff % 60000) / 1000);
        const text = `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
        els.forEach(el => el.textContent = text);
      };

      update();
      setInterval(update, 1000);
    }
  };

  // ========== PDP GALLERY v2 (mobile swipe + thumbs) ==========
  const PdpGallery = {
    init() {
      const galleries = $$('[data-pdp-gallery]');
      galleries.forEach(gallery => this.setupGallery(gallery));
    },

    setupGallery(gallery) {
      const slides = $$('[data-pdp-slide]', gallery);
      const thumbs = $$('[data-pdp-thumb]', gallery);
      const slider = $('[data-pdp-slider]', gallery);
      if (!slides.length || !slider) return;

      let current = 0;

      const goTo = (i, scroll = true) => {
        if (i < 0 || i >= slides.length) return;
        current = i;

        // Update thumbs
        thumbs.forEach(t => t.classList.remove('is-active'));
        const thumb = thumbs.find(t => parseInt(t.dataset.pdpThumb) === i);
        if (thumb) {
          thumb.classList.add('is-active');
          // Scroll thumb into view if needed
          thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }

        if (scroll) {
          const slide = slides[i];
          slider.scrollTo({
            left: slide.offsetLeft,
            behavior: 'smooth'
          });
        }
      };

      // Thumb click
      thumbs.forEach(thumb => {
        thumb.addEventListener('click', () => {
          goTo(parseInt(thumb.dataset.pdpThumb));
        });
      });

      // Detect scroll to update active slide
      let scrollTimeout;
      slider.addEventListener('scroll', () => {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => {
          const scrollLeft = slider.scrollLeft;
          const slideWidth = slider.offsetWidth;
          const newIndex = Math.round(scrollLeft / slideWidth);
          if (newIndex !== current && newIndex >= 0 && newIndex < slides.length) {
            current = newIndex;
            thumbs.forEach(t => t.classList.remove('is-active'));
            const thumb = thumbs.find(t => parseInt(t.dataset.pdpThumb) === newIndex);
            if (thumb) {
              thumb.classList.add('is-active');
              thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
            }
          }
        }, 100);
      });

      // Expose for variant change
      gallery._goTo = goTo;
    }
  };

  // ========== PDP VARIANTS ==========
  const PdpVariants = {
    init() {
      const forms = $$('[data-product-form]');
      forms.forEach(form => this.setupForm(form));
    },

    setupForm(form) {
      const select = form.querySelector('[data-variant-select]');
      if (!select) return;

      const buttons = form.querySelectorAll('[data-option-position][data-option-value]');
      const priceEl = form.querySelector('[data-pdp-current-price]');
      const compareEl = form.querySelector('[data-pdp-compare-price]');
      const atc = form.querySelector('.pdp-atc');
      const stockCount = form.querySelector('[data-stock-count]');
      const stockMsg = form.querySelector('[data-stock-msg]');
      const stockBlock = form.querySelector('[data-stock-block]');

      this.updateStock(form, stockCount, stockMsg, stockBlock);

      buttons.forEach(btn => {
        btn.addEventListener('click', () => {
          if (btn.classList.contains('is-unavailable')) return;
          const pos = btn.dataset.optionPosition;
          form.querySelectorAll(`[data-option-position="${pos}"]`).forEach(b => b.classList.remove('is-active'));
          btn.classList.add('is-active');

          const label = form.querySelector(`[data-variant-current-${pos}]`);
          if (label) label.textContent = btn.dataset.optionValue;

          this.updateVariant(form, select, priceEl, compareEl, atc);
          this.updateStock(form, stockCount, stockMsg, stockBlock);
          this.updateGalleryImage(form);
        });
      });
    },

    updateStock(form, stockCount, stockMsg, stockBlock) {
      if (!stockBlock) return;

      // Parser le map de stocks manuels depuis l'attribut data-manual-stock du form
      let manualMap = {};
      try {
        manualMap = JSON.parse(form.dataset.manualStock || '{}');
      } catch (e) {
        manualMap = {};
      }

      // Récupérer la variante actuellement sélectionnée
      const select = form.querySelector('[data-variant-select]');
      if (!select) {
        stockBlock.style.display = 'none';
        return;
      }
      const selectedOption = select.options[select.selectedIndex];
      const variantTitle = selectedOption?.dataset.variantTitle || selectedOption?.text?.trim();

      // Chercher dans le map (avec tolérance sur les espaces autour du /)
      let stock = manualMap[variantTitle];
      if (stock === undefined && variantTitle) {
        // Essayer variantes du format : "XS/Bleu" vs "XS / Bleu"
        const normalized = variantTitle.replace(/\s*\/\s*/g, ' / ');
        stock = manualMap[normalized];
        if (stock === undefined) {
          const compact = variantTitle.replace(/\s*\/\s*/g, '/');
          stock = manualMap[compact];
        }
      }

      if (stock === undefined || stock === null) {
        // Pas de stock défini pour cette variante → masquer le bloc
        stockBlock.style.display = 'none';
        return;
      }

      stockBlock.style.display = '';
      if (stockCount) stockCount.textContent = stock;
      if (stockMsg) {
        if (stock < 10) stockMsg.textContent = 'Stock très faible';
        else if (stock < 20) stockMsg.textContent = 'Très demandée';
        else stockMsg.textContent = 'Disponible';
      }
    },

    updateVariant(form, select, priceEl, compareEl, atc) {
      const selected = [];
      form.querySelectorAll('[data-option-position].is-active').forEach(btn => {
        selected[parseInt(btn.dataset.optionPosition) - 1] = btn.dataset.optionValue;
      });

      if (selected.length === 0) return;

      const targetTitle = selected.join(' / ');
      const options = Array.from(select.options);
      const match = options.find(opt => opt.text.trim() === targetTitle);

      if (match) {
        select.value = match.value;
        if (priceEl) priceEl.textContent = match.dataset.price || priceEl.textContent;
        if (compareEl && match.dataset.comparePrice) compareEl.textContent = match.dataset.comparePrice;
        if (atc) {
          if (match.disabled) {
            atc.disabled = true;
            atc.innerHTML = 'Rupture de stock';
          } else {
            atc.disabled = false;
            atc.innerHTML = `Ajouter au panier — <span data-pdp-current-price>${match.dataset.price}</span>`;
          }
        }
        this.markUnavailable(form, options);
      }
    },

    markUnavailable(form, options) {
      form.querySelectorAll('[data-option-position]').forEach(btn => {
        const pos = parseInt(btn.dataset.optionPosition) - 1;
        const value = btn.dataset.optionValue;
        const currentSelections = [];
        form.querySelectorAll('[data-option-position].is-active').forEach(b => {
          currentSelections[parseInt(b.dataset.optionPosition) - 1] = b.dataset.optionValue;
        });
        currentSelections[pos] = value;

        const targetTitle = currentSelections.filter(Boolean).join(' / ');
        const match = options.find(opt => opt.text.trim() === targetTitle);

        if (match && match.disabled) {
          btn.classList.add('is-unavailable');
        } else {
          btn.classList.remove('is-unavailable');
        }
      });
    },

    updateGalleryImage(form) {
      // Look for the active variant ID and its associated image
      const select = form.querySelector('[data-variant-select]');
      if (!select) return;
      const selectedOption = select.options[select.selectedIndex];
      if (!selectedOption) return;
      const imgIndex = selectedOption.dataset.imageIndex;
      if (imgIndex === undefined || imgIndex === '') return;

      const gallery = $('[data-pdp-gallery]');
      if (!gallery || typeof gallery._goTo !== 'function') return;
      gallery._goTo(parseInt(imgIndex));
    }
  };

  // ========== FAQ ==========
  const FAQ = {
    init() {
      $$('[data-faq]').forEach(item => {
        item.addEventListener('click', () => {
          item.classList.toggle('is-open');
        });
      });
    }
  };

  // ========== SIZE GUIDE MODAL ==========
  const SizeGuide = {
    init() {
      const modal = $('[data-size-guide-modal]');
      if (!modal) return;

      $$('[data-size-guide-open]').forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          modal.classList.add('is-open');
          document.body.style.overflow = 'hidden';
        });
      });

      $$('[data-size-guide-close]').forEach(btn => {
        btn.addEventListener('click', () => {
          modal.classList.remove('is-open');
          document.body.style.overflow = '';
        });
      });

      modal.addEventListener('click', (e) => {
        if (e.target === modal) {
          modal.classList.remove('is-open');
          document.body.style.overflow = '';
        }
      });
    }
  };

  // ========== SCROLL REVEAL ==========
  const ScrollReveal = {
    init() {
      if (!('IntersectionObserver' in window)) return;
      const els = $$('[data-reveal]');
      if (!els.length) return;
      const obs = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            obs.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1 });
      els.forEach(el => obs.observe(el));
    }
  };

  // ========== INIT ==========
  const init = () => {
    CartDrawer.init();
    CartTimer.refresh();
    MobileMenu.init();
    Countdown.init();
    PdpGallery.init();
    PdpVariants.init();
    FAQ.init();
    SizeGuide.init();
    ScrollReveal.init();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.theme = window.theme || {};
  window.theme.Cart = Cart;
  window.theme.CartDrawer = CartDrawer;
  window.theme.CartTimer = CartTimer;
  window.theme.formatMoney = formatMoney;
})();